import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EnvironmentLoader } from '../../../environments/utils/environment-loader.util';
import { IGovService } from './igov.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class IGAEADLookupService {

    public headers;

    constructor(
        private http: HttpClient,
        private igvoService: IGovService
    ) {
        this.headers = new HttpHeaders({ 'Content-Type': 'application/json'});
    }

    getSessions() {
        const env = EnvironmentLoader.environment.branch;
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/getlookups/SESS`, { headers: this.headers });
    }
    getSessions1() {
        const env = EnvironmentLoader.environment.branch;
        //return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/getlookups/SESS`, { headers: this.headers });
    }

    getAgendas(currentSession) {
        const env = EnvironmentLoader.environment.branch;
        currentSession = currentSession == 'is' ? 'IS' : currentSession;
        return this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/getlookups/getAgendas/${currentSession}`, { headers: this.headers });
    }

    getSession(currentSession){
        currentSession = currentSession == 'is' ? 'IS' : currentSession;
        currentSession = currentSession == '4' ? '4th session' : currentSession;
        //currentSession = currentSession == '25' ? 'Twenty-fifth session' : currentSession;
        currentSession = currentSession == 'ess11' ? 'ES-11' : currentSession;
        currentSession = currentSession == 'ess10' ? 'ES-10' : currentSession;
        return currentSession
    }

    async getGeneralInfo(currentSession, page, body) {
        currentSession = this.getSession(currentSession);
        let generalInfos: any =  await firstValueFrom(this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/lookups/getGeneralInfo/${currentSession}`, { headers: this.headers }));
        return generalInfos && generalInfos.find(generalInfo => generalInfo.GI_Module == page && generalInfo.GI_Body == body);
    }

    async getGeneralInfoByModule(page) {
        const env = EnvironmentLoader.environment.branch;
        // console.log('page ', page);
        // console.log('body ', body);
        let generalInfos: any =  await firstValueFrom(this.http.get(`${EnvironmentLoader.environment.igovAuthEndpoint}/lookups/getGeneralInfoByModule/${page}`, { headers: this.headers }));
        return generalInfos && generalInfos.find(generalInfo => generalInfo.GI_Module == page);
    }

    toTitleCase(str) {
        if(str=='is'){
            return 'IS'
        }
        if(str=='ess11'){
            return 'ESS11'
        }
        if(str=='ess10'){
            return 'ESS10'
        }
        return str.replace(
          /\w\S*/g,
          text => text.charAt(0).toUpperCase() + text.substring(1).toLowerCase()
        );
    }
    getCommittee(body){
        let bodyName =''
        switch(body){
            case 'ga' :
                bodyName='General Assembly';
                break;
            case 'plenary' :
                bodyName='GA';
                break;
            case 'c1' :
                bodyName='First Committee';
                break;
            case 'c2' :
                bodyName='Second Committee';
                break;
            case 'c3' :
                bodyName='Third Committee';
                break;
            case 'c4' :
                bodyName='Fourth Committee';
                break;
            case 'c5' :
                bodyName='Fifth Committee';
                break;
            case 'c6' :
                bodyName='Sixth Committee';
                break;
            case 'wgsr' :
                bodyName='Working Group on the Strengthening and Revitalizing of the Work of the General Assembly';
                break;
            case 'c34' :
                bodyName='Special Committee on Peacekeeping Operations';
            case 'c24' :
                bodyName='Special Committee on the Situation with regard to the Implementation of the Declaration on the Granting of Independence to Colonial Countries and Peoples';
                break;
            case 'ffd4pc' :
                bodyName='Preparatory Committee for the Fourth International Conference on Financing for Development';
                break;
            case 'ffd4' :
                bodyName='Fourth International Conference on Financing for Development';
                break;
            case 'ungegn' :
                bodyName='United Nations Group of Experts on Geographical Names';
                break;
            case 'ggim':
                bodyName='Committee of Experts on Global Geospatial Information Management';
                break;
            case 'hlpf' :
                bodyName='High-level political forum on sustainable development, convened under the auspices of the Council';
                break;
            case 'unff' :
                bodyName='United Nations Forum on Forests';
                break;
            case 'unpfii':
                bodyName='Permanent Forum on Indigenous Issues';
                break;
            case 'csocd':
                bodyName='Commission for Social Development';
                break;
            case 'statscomm':
                bodyName='Statistical Commission';
                break;
            case 'cngos':
                bodyName='Committee on Non-Governmental Organizations';
                break;
            case 'cngos':
                bodyName='Committee on Non-Governmental Organizations';
                break;
            case 'undc':
                bodyName='United Nations Disarmament Commission';
                break;
            case 'cpd': 
                bodyName= 'Commission on Population and Development';
                break;
            case 'ffd': 
                bodyName= 'Forum on financing for development follow-up';
                break;

        }
        return bodyName;
    }
    mainBody(routerUrl){
        let url = routerUrl.split('/');
        if(url.length > 0){
            return this.getBodyText(url[1]);
        }
        return '';
    }

    getBodyText(body){
        let page= '';
        switch (body){
            case 'ga':
                page= 'GA';
                break;
            case 'conferences' :
                page = 'Conferences';
                break;
            case 'ecosoc' :
                page = 'Economic and Social Council';
                break;
        }
        return page;
    }

    mainBodyURLValue(routerUrl){
        let url = routerUrl.split('/');
        if(url.length > 0){
            if(url[1].toLowerCase()=='a'){
                return 'ga'
            }
            if(url[1].toLowerCase()=='e'){
                return 'ecosoc'
            }
            return url[1];
        }
        return '';
    }
    getStaticSessions(){
        return [{
            LKP_ValueShort: '81st',
            LKP_Value: 'Eighty-first session'
        },{
            LKP_ValueShort: '80th',
            LKP_Value: 'Eightieth session'
        },{
            LKP_ValueShort: '79th',
            LKP_Value: 'Seventy-ninth session'
        },{
            LKP_ValueShort: '78th',
            LKP_Value: 'Seventy-eighth session'
        },{
            LKP_ValueShort: '77th',
            LKP_Value: 'Seventy-seventh session'
        },{
            LKP_ValueShort: '76th',
            LKP_Value: 'Seventy-sixth session'
        },{
            LKP_ValueShort: '75th',
            LKP_Value: 'Seventy-fifth session'
        },{
            LKP_ValueShort: '74th',
            LKP_Value: 'Seventy-fourth session'
        },{
            LKP_ValueShort: '73rd',
            LKP_Value: 'Seventy-third session'
        },{
            LKP_ValueShort: '72nd',
            LKP_Value: 'Seventy-second session'
        },{
            LKP_ValueShort: '71st',
            LKP_Value: 'Seventy-first session'
        },{
            LKP_ValueShort: '70th',
            LKP_Value: 'Seventieth session'
        },{
            LKP_ValueShort: '69th',
            LKP_Value: 'Sixty-ninth session'
        },{
            LKP_ValueShort: '68th',
            LKP_Value: 'Sixty-eighth session'
        },{
            LKP_ValueShort: '67th',
            LKP_Value: 'Sixty-seventh session'
        },{
            LKP_ValueShort: '66th',
            LKP_Value: 'Sixty-sixth session'
        },{
            LKP_ValueShort: '65th',
            LKP_Value: 'Sixty-fifth session'
        },{
            LKP_ValueShort: '64th',
            LKP_Value: 'Sixty-fourth session'
        },{
            LKP_ValueShort: '63rd',
            LKP_Value: 'Sixty-third session'
        },{
            LKP_ValueShort: '62nd',
            LKP_Value: 'Sixty-second session'
        },{
            LKP_ValueShort: '61st',
            LKP_Value: 'Sixty-first session'
        },{
            LKP_ValueShort: '60th',
            LKP_Value: 'Sixtieth session'
        },{
            LKP_ValueShort: '59th',
            LKP_Value: 'Fifty-ninth session'
        },{
            LKP_ValueShort: '58th',
            LKP_Value: 'Fifty-eighth session'
        },{
            LKP_ValueShort: '57th',
            LKP_Value: 'Fifty-seventh session'
        },{
            LKP_ValueShort: '56th',
            LKP_Value: 'Fifty-sixth session'
        },{
            LKP_ValueShort: '55th',
            LKP_Value: 'Fifty-fifth session'
        },{
            LKP_ValueShort: '54th',
            LKP_Value: 'Fifty-fourth session'
        },{
            LKP_ValueShort: '53rd',
            LKP_Value: 'Fifty-third session'
        },{
            LKP_ValueShort: '52nd',
            LKP_Value: 'Fifty-second session'
        },{
            LKP_ValueShort: '51st',
            LKP_Value: 'Fifty-first session'
        },{
            LKP_ValueShort: '50th',
            LKP_Value: 'Fiftieth session'
        },{
            LKP_ValueShort: '49th',
            LKP_Value: 'Forty-ninth session'
        },{
            LKP_ValueShort: '48th',
            LKP_Value: 'Forty-eighth session'
        },{
            LKP_ValueShort: '47th',
            LKP_Value: 'Forty-seventh session'
        },{
            LKP_ValueShort: '46th',
            LKP_Value: 'Forty-sixth session'
        },{
            LKP_ValueShort: '45th',
            LKP_Value: 'Forty-fifth session'
        },{
            LKP_ValueShort: '44th',
            LKP_Value: 'Forty-fourth session'
        },{
            LKP_ValueShort: '43rd',
            LKP_Value: 'Forty-third session'
        },{
            LKP_ValueShort: '42nd',
            LKP_Value: 'Forty-second session'
        },{
            LKP_ValueShort: '41st',
            LKP_Value: 'Forty-first session'
        },{
            LKP_ValueShort: '40th',
            LKP_Value: 'Fortieth session'
        },{
            LKP_ValueShort: '39th',
            LKP_Value: 'Thirty-ninth session'
        },{
            LKP_ValueShort: '38th',
            LKP_Value: 'Thirty-eighth session'
        },{
            LKP_ValueShort: '37th',
            LKP_Value: 'Thirty-seventh session'
        },{
            LKP_ValueShort: '36th',
            LKP_Value: 'Thirty-sixth session'
        },{
            LKP_ValueShort: '35th',
            LKP_Value: 'Thirty-fifth session'
        },{
            LKP_ValueShort: '34th',
            LKP_Value: 'Thirty-fourth session'
        },{
            LKP_ValueShort: '33rd',
            LKP_Value: 'Thirty-third session'
        },{
            LKP_ValueShort: '32nd',
            LKP_Value: 'Thirty-second session'
        },{
            LKP_ValueShort: '31st',
            LKP_Value: 'Thirty-first session'
        },{
            LKP_ValueShort: '30th',
            LKP_Value: 'Thirtieth session'
        },{
            LKP_ValueShort: '29th',
            LKP_Value: 'Twenty-ninth session'
        },{
            LKP_ValueShort: '28th',
            LKP_Value: 'Twenty-eighth session'
        },{
            LKP_ValueShort: '27th',
            LKP_Value: 'Twenty-seventh session'
        },{
            LKP_ValueShort: '26th',
            LKP_Value: 'Twenty-sixth session'
        },{
            LKP_ValueShort: '25th',
            LKP_Value: 'Twenty-fifth session'
        },{
            LKP_ValueShort: '24th',
            LKP_Value: 'Twenty-fourth session'
        },{
            LKP_ValueShort: '23rd',
            LKP_Value: 'Twenty-third session'
        },{
            LKP_ValueShort: '22nd',
            LKP_Value: 'Twenty-second session'
        },{
            LKP_ValueShort: '21st',
            LKP_Value: 'Twenty-first session'
        },{
            LKP_ValueShort: '20th',
            LKP_Value: 'Twentieth session'
        },{
            LKP_ValueShort: '19th',
            LKP_Value: 'Nineteenth session'
        },{
            LKP_ValueShort: '18th',
            LKP_Value: 'Eighteenth session'
        },{
            LKP_ValueShort: '17th',
            LKP_Value: 'Seventeenth session'
        },{
            LKP_ValueShort: '16th',
            LKP_Value: 'Sixteenth session'
        },{
            LKP_ValueShort: '15th',
            LKP_Value: 'Fifteenth session'
        },{
            LKP_ValueShort: '14th',
            LKP_Value: 'Fourteenth session'
        },{
            LKP_ValueShort: '13th',
            LKP_Value: 'Thirteenth session'
        },{
            LKP_ValueShort: '12th',
            LKP_Value: 'Twelfth session'
        },{
            LKP_ValueShort: '11th',
            LKP_Value: 'Eleventh session'
        },{
            LKP_ValueShort: '10th',
            LKP_Value: 'Tenth session'
        },{
            LKP_ValueShort: '9th',
            LKP_Value: 'Ninth session'
        },{
            LKP_ValueShort: '8th',
            LKP_Value: 'Eighth session'
        },{
            LKP_ValueShort: '7th',
            LKP_Value: 'Seventh session'
        },{
            LKP_ValueShort: '6th',
            LKP_Value: 'Sixth session'
        },{
            LKP_ValueShort: '5th',
            LKP_Value: 'Fifth session'
        },{
            LKP_ValueShort: '4th',
            LKP_Value: 'Fourth session'
        },{
            LKP_ValueShort: '3rd',
            LKP_Value: 'Third session'
        },{
            LKP_ValueShort: '2nd',
            LKP_Value: 'Second session'
        },{
            LKP_ValueShort: '1st',
            LKP_Value: 'First session'
        },{
            LKP_ValueShort: 'ess1000',
            LKP_Value: 'Tenth Emergency Special Session'
        },{
            LKP_ValueShort: 'ess1111',
            LKP_Value: 'Eleventh Emergency Special Session'
        }]
    }

}
